export function createIdempotencyKey() {
  if (crypto.randomUUID) return crypto.randomUUID();
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}

export function createProofCode(length = 10) {
  const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  return [...bytes].map((byte) => alphabet[byte % alphabet.length]).join('');
}

export function bytesToSize(bytes) {
  if (!bytes) return '0 KB';
  const units = ['B', 'KB', 'MB', 'GB'];
  const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  return `${(bytes / 1024 ** index).toFixed(index === 0 ? 0 : 1)} ${units[index]}`;
}

export function getDraftSession() {
  const key = 'idxSurveyDraft.v1';
  const existing = localStorage.getItem(key);
  if (existing) {
    try {
      const parsed = JSON.parse(existing);
      if (parsed.idempotencyKey && parsed.proofCode) return { storageKey: key, ...parsed };
    } catch {
      localStorage.removeItem(key);
    }
  }

  const next = {
    idempotencyKey: createIdempotencyKey(),
    proofCode: createProofCode()
  };
  localStorage.setItem(key, JSON.stringify(next));
  return { storageKey: key, ...next };
}

export function resetDraftSession(storageKey) {
  localStorage.removeItem(storageKey);
}
